import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_PREPAIDS_ACTION_TYPE } from '../actions';

const initialState = {
  prepaidLoanFees: [],
  interestCreditFundingDate: null,
  interestCreditNoteDate: null,
  interestCreditDisbursementDate: null,
  interestCreditRescissionDate: null,
  hasInterestCredit: null,
  manualDailyPrepaidInterest: null,
};

const loanPrepaidsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case LOAN_PREPAIDS_ACTION_TYPE.GET_PREPAIDS:
      case LOAN_PREPAIDS_ACTION_TYPE.EDIT_PREPAIDS:
        return payload ? { ...state, ...payload } : initialState;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanPrepaidsReducer;
